import {AbstractApiRequestInterceptor} from 'core/abstract/AbstractApiRequestInterceptor';
import {IRequestOptions, TRequestParameters} from 'core/types';

export class AbortRequestInterceptor extends AbstractApiRequestInterceptor {
    public readonly requestMap: Record<string, AbortController>;
    private static instance: AbortRequestInterceptor;

    private constructor() {
        super();

        this.requestMap = {};
    }

    public static getInstance(): AbortRequestInterceptor {
        if (!AbortRequestInterceptor.instance) {
            AbortRequestInterceptor.instance = new AbortRequestInterceptor();
        }

        return AbortRequestInterceptor.instance;
    }

    public registerRequest(request: TRequestParameters<RequestInit>, id: NonNullable<IRequestOptions['id']>): void {
        const abortController = new AbortController();

        if (!request.options) {
            return;
        }

        request.options.signal = abortController.signal;

        this.requestMap[id] = abortController;
    }

    public intercept(
        request: TRequestParameters<RequestInit>,
        {cancellable, id}: IRequestOptions,
    ): TRequestParameters<RequestInit> {
        if (cancellable && id) {
            if (!this.requestMap[id]) {
                this.registerRequest(request, id);
            } else {
                this.requestMap[id].abort();
                delete this.requestMap[id];

                this.registerRequest(request, id);
            }
        }

        return request;
    }

    public static abort(id: NonNullable<IRequestOptions['id']>): void {
        const abortInterceptor = AbortRequestInterceptor.getInstance();

        const request = abortInterceptor.requestMap[id];

        if (!request) {
            return;
        }

        request.abort();
    }
}
